export const LOADING_RESULTS = 'Loading results';
export const REFINE_FILTERS_OR_UPDATE_SEARCH =
  'Please, refine your filters or update the search parameters';
